import React from 'react';
import {T} from '../../utils/I18n/I18n';
import SlickSlider from 'react-slick';
import Loader from '../../components/Loader/Loader';
import ProductItem from '../../components/Category/ProductItem/ProductItem';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ProductSlider.scss';
import {useRecommendationsQuarticon} from "../../hooks/useQuarticonHooks";
import {normalizeProductItems} from "../../components/Category/Products/Products";
import useResponsive from "../../hooks/useResponsive";
import useHydrationDelay from "../../hooks/useHydrationDelay";
import useCookiebotConsent from "../../hooks/useCookiebotConsent";

const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  className: 'center',
  centerPadding: '1px',
  speed: 700,
  margin: 0,
  adaptiveHeight: true,
  slidesToShow: 5, // n items
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1225,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1100,
      settings: {
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 918,
      settings: {
        arrows: true,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const QuarticonProductSlider = ({ type, isHome, categoryId, isCart,cnt= 3, sku=null}) => {
  // Wszystkie hooki muszą być wywołane przed warunkowymi zwrotami
  const isHydrated = useHydrationDelay();
  const {isMobile} = useResponsive();
  const { hasConsent: hasMarketingConsent, isLoading: cookiebotLoading } = useCookiebotConsent();
  const {
    recomendations,
    loading,
  } = useRecommendationsQuarticon(sku, type, categoryId);

  // Renderuj placeholder podczas hydracji lub ładowania Cookiebot
  if (!isHydrated || cookiebotLoading) {
    return (
      <div className="quarticon-slider-placeholder" style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    );
  }

  // Brak zgody na marketing - nie renderuj Quarticon
  if (!hasMarketingConsent) {
    return <div />;
  }

  const mergedProducts = recomendations;
  if (loading) {
    return (
        <div className="loader-container">
          <Loader/>;
        </div>
    );
  }

  if (!recomendations) {
    return <></>;
  }

  const productItems = (mergedProducts && normalizeProductItems(mergedProducts)) || null;


  if(isMobile){
    return (
    <>
      {productItems && (
          <div className='products__list'>
            {!isHome && (
                <h3 className="quarticon-slider__title">
                  <T id="product.recommendedProducts" />
                </h3>
            )}
            <ul className='products'>

                {productItems.slice(0, 4).map((item,index) => <ProductItem key={index} product={item} isCms isQuarticon />)}

            </ul>
          </div>
      )}
    </>
    )
  }

  return (
    <>
      {productItems && (
        <div>
          {!isHome && (
            <h3 className="quarticon-slider__title">
              <T id="product.recommendedProducts" />
            </h3>
          )}
          <ul>
            <SlickSlider
              {...sliderSettings}
              {...{ slidesToShow: cnt }}
              {...{ slidesToScroll: cnt }}
              className="product-slider"
            >
              {productItems && productItems.map((item,index) => <ProductItem key={index} product={item} isCms isQuarticon />)}
            </SlickSlider>
          </ul>
        </div>
      )}
    </>
  );
};

export default React.memo(QuarticonProductSlider);
